const kudozLogo = "/kudoz-icon-disc.png";
import { cn } from "@/lib/utils";

interface KudozIconProps {
  className?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
}

const sizeClasses = {
  xs: "w-3 h-3",
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-6 h-6",
  xl: "w-8 h-8",
};

export function KudozIcon({ className, size = "md" }: KudozIconProps) {
  return (
    <img
      src={kudozLogo}
      alt="Kudoz"
      className={cn(sizeClasses[size], className)}
    />
  );
}

export default KudozIcon;
